export default {
  data() {
    return {
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      disableRouting: false
    };
  },
  methods: {
    buildSearchQuery() {
      const query = {};

      if (!this.filters) return query;

      Object.entries(this.filters).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') return;

        if (Array.isArray(value)) {
          if (value.length > 0) query[key] = value.join(',');
        }
        else if (typeof value === 'number') {
          if (value > 0) query[key] = value;
        }
        else if (typeof value === 'boolean') {
          query[key] = value;
        }
        else {
          query[key] = value;
        }
      });

      return query;
    },
    async onSearch() {
      if (this._isDestroyed) return;

      this.currentPage = 1;

      if (!this.disableRouting) {
        const routePath = this.routePath || this.$route.path;
        await this.$router.push({
          path: routePath,
          query: this.buildSearchQuery(),
          hash: '#page/' + this.currentPage
        }).catch(() => {});
      }

      await this.loadData();
    },
    async onPagination(e, page) {
      if (this.disableRouting && e) {
        e.preventDefault();
      }

      this.currentPage = page;
      await this.loadData();
    },
    async onPerPageChange(newPerPage) {
      if (newPerPage) this.perPage = newPerPage;

      this.currentPage = 1;
      await this.loadData();
    },
    getPage(hash) {
      if (!hash) return 1;

      const page = hash.split("/").pop();
      return Number(page);
    },
    async loadData() {
      if (typeof this.getItems === 'function') await this.getItems();
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilites/pageSearchService.js